import { crudMdActions } from "@/services/crud-md-actions";

const name = "country-regions";

export default {
  name,
  ...crudMdActions(name),
};
